import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
	standalone: false,
	selector: 'bt-paginator',
	templateUrl: './paginator.component.html',
	styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnChanges {
	@Input() pageNumber = 1;
	@Input() pageSize = 20;
	@Input() totalNumber = 0;
	@Input() totalPages = 0;

	@Output() clickPage = new EventEmitter<{ pageNumber: number; pageSize: number }>();

	startNumber = 0;
	endNumber = 0; 

	ngOnChanges(changes: SimpleChanges) {
		const page = Math.max(this.pageNumber || 1, 1);
		const size = Math.max(this.pageSize || 20, 1);
		const total = Math.max(this.totalNumber || 0, 0);

		this.totalPages = Math.ceil(total / size);

		this.startNumber = total === 0 ? 0 : (page - 1) * size + 1;

		this.endNumber = total === 0 ? 0 : Math.min(page * size, total);
	}

	onClickPage(page: number) {
		const safePage = Math.min(Math.max(page, 1), this.totalPages || 1);
		this.clickPage.emit({ pageNumber: safePage, pageSize: this.pageSize });
	}

	onPageSizeChange(event: any) {
		const newSize = +event.target.value;
		this.pageSize = newSize;
		this.onClickPage(1);
	}
}
